<template>
  <AnalyticsChartWrapper
    ref="chartWrapper"
    :config="data"
    @titleChanged="changeHighChartsTitle"
    @captionChanged="changeHighChartsCaption"
  >
    <template slot="chart">
      <BarChart
        ref="chartRef"
        :chart="data"
        @adjustMenuIcon="adjustMenuIcon"
      />
    </template>
  </AnalyticsChartWrapper>
</template>

<script>
import AnalyticsChartWrapper from '@/components/analytics/outcomesExplorer/charts/AnalyticsChartWrapper'
import BarChart from '@/components/common/BarChart'
import { ChartChangesHelper } from '@/mixins/analytics/Charts/ChartChangesHelper'

export default {
  name: 'AnalyticsResultChartsPatientStatusDaysFromAdmissionToDischarge',
  components: {
    AnalyticsChartWrapper,
    BarChart
  },
  mixins: [ChartChangesHelper],
  props: {
    programName: {
      type: String,
      default: ''
    },
    data: {}
  }
}
</script>

<style lang="scss" scoped>

</style>
